import Vue from "vue";
import VueDadata from "vue-dadata";
Vue.use(VueDadata);
